import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'paykaCurrency',
  standalone: true
})
export class PaykaCurrencyPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {
  }

  transform(value: any, currency: string = 'PLN', digitsInfo: string = '1.2-2', locale: string = 'pl'): SafeHtml {
    if (value === null) {
      return '';
    }
    let formattedNumber = '';
    formattedNumber = this.decimalPipe.transform(value, digitsInfo, locale);
    switch (currency) {
      case 'USD':
        return '$' + formattedNumber;
      case 'EUR':
        return '€' + formattedNumber;
      case 'PLN':
        return formattedNumber + ' zł';
      default:
        return formattedNumber + ' ' + currency;
    }
  }

}
